<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>BRIGHT PAYMENT POINT REPORT</h4>
			</div>

			<div class="col-md-12" v-if="false">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop:'8px' }">
                    <div slot="header" class="clearfix" v-if="false">
                        <strong><span>Bright Payment Point Report</span></strong>
                    </div>
                    <div>
                       
                    </div>
                </el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
    },
    methods:{

	}
}
</script>